import {Alert} from "antd";
import {
  User,
} from "../../../api/models";

const AlertEngineerLock = ( props:{
  engineer:User | undefined
}) => {
  if ( !props.engineer ) return <></>

  return <div style={{marginBottom: "1rem"}}>
    <Alert
        type="error"
        message={`This quote has been locked by engineering.  Please contact ${props.engineer.name} (${props.engineer.email}) with any questions.`}
        closable={true}
    />
  </div>
}

export default AlertEngineerLock;
